export default "__VITE_ASSET__Cint4e4e__"